/**
 * 车辆异常时长维护 — Mock 数据（内存数据库，支持 CRUD）
 *
 * 在 URL 加 ?mock=1 启用 mock 模式
 */

// ============ 内存数据库 ============

let nextId = 10031;
let nextProblemTypeId = 7;

// 问题类型
let problemTypeStore = [
  { id: 1, name: '硬件问题' },
  { id: 2, name: '软件问题' },
  { id: 3, name: '交通事故' },
  { id: 4, name: '路权问题' },
  { id: 5, name: '运营问题' },
  { id: 6, name: '其他问题' },
];

// 异常记录
let recordStore = [
  {
    id: 10001, supplier: '京东', region: '华北', province: '北京', city: '北京市',
    stationName: '北京朝阳网点', provinceId: 1, cityId: 11, vehicleName: 'JD-001', stationBaseId: 101, startOriginalDate: '2026-07-20',
    problemTypeNames: '硬件问题、软件问题', problemTypeIds: [1, 2],
    problemDetail: '激光雷达故障，需要返厂维修', recovered: 0, endOriginalDate: null as string | null,
    impactDays: 10, taskRecord: 3, source: 'MANUAL', modifyUser: 'zhangsan', modifyTime: '2026-07-29 14:30:00',
  },
  {
    id: 10002, supplier: '新石器', region: '华东', province: '上海', city: '上海市',
    stationName: '上海浦东网点', provinceId: 2, cityId: 21, vehicleName: 'XM-001', stationBaseId: 201, startOriginalDate: '2026-07-15',
    problemTypeNames: '交通事故', problemTypeIds: [3],
    problemDetail: '与社会车辆发生轻微剐蹭', recovered: 1, endOriginalDate: '2026-07-18',
    impactDays: 3, taskRecord: 0, source: 'IMPORT', modifyUser: 'lisi', modifyTime: '2026-07-18 09:00:00',
  },
  {
    id: 10003, supplier: '美团', region: '华北', province: '北京', city: '北京市',
    stationName: '北京海淀网点', provinceId: 1, cityId: 11, vehicleName: 'MT-001', stationBaseId: 102, startOriginalDate: '2026-07-25',
    problemTypeNames: '路权问题', problemTypeIds: [4],
    problemDetail: '区域限行，无法正常运营', recovered: 0, endOriginalDate: null,
    impactDays: 5, taskRecord: 1, source: 'MANUAL', modifyUser: 'wangwu', modifyTime: '2026-07-29 16:00:00',
  },
  {
    id: 10004, supplier: '京东', region: '华北', province: '北京', city: '北京市',
    stationName: '北京朝阳网点', provinceId: 1, cityId: 11, vehicleName: 'JD-002', stationBaseId: 101, startOriginalDate: '2026-07-10',
    problemTypeNames: '软件问题', problemTypeIds: [2],
    problemDetail: '自动驾驶算法异常，频繁急刹', recovered: 1, endOriginalDate: '2026-07-14',
    impactDays: 4, taskRecord: 5, source: 'MANUAL', modifyUser: 'zhangsan', modifyTime: '2026-07-14 10:00:00',
  },
  {
    id: 10005, supplier: '京东', region: '华东', province: '上海', city: '上海市',
    stationName: '上海浦东网点', provinceId: 2, cityId: 21, vehicleName: 'JD-003', stationBaseId: 201, startOriginalDate: '2026-07-22',
    problemTypeNames: '硬件问题', problemTypeIds: [1],
    problemDetail: '摄像头模组进水，画面模糊', recovered: 0, endOriginalDate: null,
    impactDays: 8, taskRecord: 0, source: 'IMPORT', modifyUser: 'lisi', modifyTime: '2026-07-29 11:00:00',
  },
  {
    id: 10006, supplier: '新石器', region: '华北', province: '河北', city: '石家庄市',
    stationName: '石家庄长安网点', provinceId: 3, cityId: 31, vehicleName: 'XM-002', stationBaseId: 301, startOriginalDate: '2026-07-05',
    problemTypeNames: '运营问题', problemTypeIds: [5],
    problemDetail: '配送路线规划不合理导致超时', recovered: 1, endOriginalDate: '2026-07-08',
    impactDays: 3, taskRecord: 12, source: 'MANUAL', modifyUser: 'wangwu', modifyTime: '2026-07-08 15:30:00',
  },
  {
    id: 10007, supplier: '美团', region: '华东', province: '江苏', city: '南京市',
    stationName: '南京江宁网点', provinceId: 4, cityId: 41, vehicleName: 'MT-002', stationBaseId: 401, startOriginalDate: '2026-07-18',
    problemTypeNames: '交通事故、硬件问题', problemTypeIds: [3, 1],
    problemDetail: '追尾事故导致前保险杠和雷达损坏', recovered: 0, endOriginalDate: null,
    impactDays: 12, taskRecord: 0, source: 'MANUAL', modifyUser: 'zhangsan', modifyTime: '2026-07-29 09:00:00',
  },
  {
    id: 10008, supplier: '京东', region: '华南', province: '广东', city: '广州市',
    stationName: '广州天河网点', provinceId: 5, cityId: 51, vehicleName: 'JD-004', stationBaseId: 501, startOriginalDate: '2026-06-28',
    problemTypeNames: '路权问题', problemTypeIds: [4],
    problemDetail: '新政策限制无人驾驶车辆通行时段', recovered: 1, endOriginalDate: '2026-07-05',
    impactDays: 7, taskRecord: 0, source: 'IMPORT', modifyUser: 'lisi', modifyTime: '2026-07-05 08:00:00',
  },
  {
    id: 10009, supplier: '新石器', region: '华南', province: '广东', city: '深圳市',
    stationName: '深圳南山网点', provinceId: 5, cityId: 52, vehicleName: 'XM-003', stationBaseId: 502, startOriginalDate: '2026-07-12',
    problemTypeNames: '软件问题', problemTypeIds: [2],
    problemDetail: '系统OTA升级失败，需要手动恢复', recovered: 1, endOriginalDate: '2026-07-13',
    impactDays: 1, taskRecord: 2, source: 'MANUAL', modifyUser: 'wangwu', modifyTime: '2026-07-13 17:00:00',
  },
  {
    id: 10010, supplier: '美团', region: '华北', province: '北京', city: '北京市',
    stationName: '北京海淀网点', provinceId: 1, cityId: 11, vehicleName: 'MT-003', stationBaseId: 102, startOriginalDate: '2026-07-01',
    problemTypeNames: '其他问题', problemTypeIds: [6],
    problemDetail: '车辆外观涂装脱落，需重新喷涂', recovered: 1, endOriginalDate: '2026-07-03',
    impactDays: 2, taskRecord: 0, source: 'MANUAL', modifyUser: 'zhangsan', modifyTime: '2026-07-03 12:00:00',
  },
  {
    id: 10011, supplier: '京东', region: '华东', province: '江苏', city: '苏州市',
    stationName: '苏州工业园网点', provinceId: 4, cityId: 42, vehicleName: 'JD-005', stationBaseId: 402, startOriginalDate: '2026-07-08',
    problemTypeNames: '硬件问题、运营问题', problemTypeIds: [1, 5],
    problemDetail: '电池续航严重衰减，影响配送效率', recovered: 0, endOriginalDate: null,
    impactDays: 22, taskRecord: 8, source: 'MANUAL', modifyUser: 'lisi', modifyTime: '2026-07-29 10:30:00',
  },
  {
    id: 10012, supplier: '美团', region: '华东', province: '上海', city: '上海市',
    stationName: '上海徐汇网点', provinceId: 2, cityId: 21, vehicleName: 'MT-004', stationBaseId: 202, startOriginalDate: '2026-07-20',
    problemTypeNames: '交通事故', problemTypeIds: [3],
    problemDetail: '转弯时与电动车发生碰撞', recovered: 1, endOriginalDate: '2026-07-25',
    impactDays: 5, taskRecord: 0, source: 'IMPORT', modifyUser: 'wangwu', modifyTime: '2026-07-25 14:00:00',
  },
  {
    id: 10013, supplier: '新石器', region: '华北', province: '北京', city: '北京市',
    stationName: '北京朝阳网点', provinceId: 1, cityId: 11, vehicleName: 'XM-004', stationBaseId: 101, startOriginalDate: '2026-07-26',
    problemTypeNames: '软件问题', problemTypeIds: [2],
    problemDetail: '定位模块信号漂移，导航偏差大', recovered: 0, endOriginalDate: null,
    impactDays: 4, taskRecord: 1, source: 'MANUAL', modifyUser: 'zhangsan', modifyTime: '2026-07-29 08:00:00',
  },
  {
    id: 10014, supplier: '京东', region: '华南', province: '广东', city: '深圳市',
    stationName: '深圳福田网点', provinceId: 5, cityId: 52, vehicleName: 'JD-006', stationBaseId: 503, startOriginalDate: '2026-07-02',
    problemTypeNames: '路权问题、运营问题', problemTypeIds: [4, 5],
    problemDetail: '施工区域临时封路，需重新规划路线', recovered: 1, endOriginalDate: '2026-07-04',
    impactDays: 2, taskRecord: 6, source: 'MANUAL', modifyUser: 'lisi', modifyTime: '2026-07-04 16:00:00',
  },
  {
    id: 10015, supplier: '美团', region: '华北', province: '河北', city: '石家庄市',
    stationName: '石家庄长安网点', provinceId: 3, cityId: 31, vehicleName: 'MT-005', stationBaseId: 301, startOriginalDate: '2026-07-14',
    problemTypeNames: '硬件问题', problemTypeIds: [1],
    problemDetail: '轮胎磨损严重，需更换', recovered: 1, endOriginalDate: '2026-07-15',
    impactDays: 1, taskRecord: 0, source: 'MANUAL', modifyUser: 'wangwu', modifyTime: '2026-07-15 11:00:00',
  },
  {
    id: 10016, supplier: '京东', region: '华东', province: '上海', city: '上海市',
    stationName: '上海浦东网点', provinceId: 2, cityId: 21, vehicleName: 'JD-007', stationBaseId: 201, startOriginalDate: '2026-06-25',
    problemTypeNames: '软件问题、硬件问题', problemTypeIds: [2, 1],
    problemDetail: '传感器融合模块异常，多传感器数据不同步', recovered: 1, endOriginalDate: '2026-07-01',
    impactDays: 6, taskRecord: 3, source: 'IMPORT', modifyUser: 'zhangsan', modifyTime: '2026-07-01 09:00:00',
  },
  {
    id: 10017, supplier: '新石器', region: '华东', province: '江苏', city: '南京市',
    stationName: '南京江宁网点', provinceId: 4, cityId: 41, vehicleName: 'XM-005', stationBaseId: 401, startOriginalDate: '2026-07-19',
    problemTypeNames: '运营问题', problemTypeIds: [5],
    problemDetail: '客户投诉配送时间过长', recovered: 0, endOriginalDate: null,
    impactDays: 11, taskRecord: 15, source: 'MANUAL', modifyUser: 'lisi', modifyTime: '2026-07-29 13:00:00',
  },
  {
    id: 10018, supplier: '美团', region: '华南', province: '广东', city: '广州市',
    stationName: '广州天河网点', provinceId: 5, cityId: 51, vehicleName: 'MT-006', stationBaseId: 501, startOriginalDate: '2026-07-06',
    problemTypeNames: '交通事故、软件问题', problemTypeIds: [3, 2],
    problemDetail: '紧急制动系统误触发导致后车追尾', recovered: 1, endOriginalDate: '2026-07-12',
    impactDays: 6, taskRecord: 0, source: 'MANUAL', modifyUser: 'wangwu', modifyTime: '2026-07-12 10:00:00',
  },
  {
    id: 10019, supplier: '京东', region: '华北', province: '北京', city: '北京市',
    stationName: '北京海淀网点', provinceId: 1, cityId: 11, vehicleName: 'JD-008', stationBaseId: 102, startOriginalDate: '2026-07-23',
    problemTypeNames: '硬件问题', problemTypeIds: [1],
    problemDetail: '线控转向系统响应延迟', recovered: 0, endOriginalDate: null,
    impactDays: 7, taskRecord: 2, source: 'MANUAL', modifyUser: 'zhangsan', modifyTime: '2026-07-29 15:00:00',
  },
  {
    id: 10020, supplier: '新石器', region: '华东', province: '上海', city: '上海市',
    stationName: '上海徐汇网点', provinceId: 2, cityId: 21, vehicleName: 'XM-006', stationBaseId: 202, startOriginalDate: '2026-07-17',
    problemTypeNames: '路权问题', problemTypeIds: [4],
    problemDetail: '学校周边限时禁行政策调整', recovered: 1, endOriginalDate: '2026-07-20',
    impactDays: 3, taskRecord: 0, source: 'IMPORT', modifyUser: 'lisi', modifyTime: '2026-07-20 08:00:00',
  },
  {
    id: 10021, supplier: '美团', region: '华东', province: '江苏', city: '苏州市',
    stationName: '苏州工业园网点', provinceId: 4, cityId: 42, vehicleName: 'MT-007', stationBaseId: 402, startOriginalDate: '2026-07-11',
    problemTypeNames: '其他问题', problemTypeIds: [6],
    problemDetail: '车载冰箱故障，冷链商品无法配送', recovered: 1, endOriginalDate: '2026-07-12',
    impactDays: 1, taskRecord: 4, source: 'MANUAL', modifyUser: 'wangwu', modifyTime: '2026-07-12 14:00:00',
  },
  {
    id: 10022, supplier: '京东', region: '华北', province: '河北', city: '石家庄市',
    stationName: '石家庄长安网点', provinceId: 3, cityId: 31, vehicleName: 'JD-009', stationBaseId: 301, startOriginalDate: '2026-07-03',
    problemTypeNames: '软件问题', problemTypeIds: [2],
    problemDetail: 'V2X通信模块固件版本不兼容', recovered: 1, endOriginalDate: '2026-07-06',
    impactDays: 3, taskRecord: 1, source: 'MANUAL', modifyUser: 'zhangsan', modifyTime: '2026-07-06 16:30:00',
  },
  {
    id: 10023, supplier: '新石器', region: '华南', province: '广东', city: '深圳市',
    stationName: '深圳南山网点', provinceId: 5, cityId: 52, vehicleName: 'XM-007', stationBaseId: 502, startOriginalDate: '2026-07-24',
    problemTypeNames: '交通事故', problemTypeIds: [3],
    problemDetail: '停车场内低速剐蹭柱子', recovered: 0, endOriginalDate: null,
    impactDays: 6, taskRecord: 0, source: 'MANUAL', modifyUser: 'lisi', modifyTime: '2026-07-29 17:00:00',
  },
  {
    id: 10024, supplier: '美团', region: '华南', province: '广东', city: '深圳市',
    stationName: '深圳福田网点', provinceId: 5, cityId: 52, vehicleName: 'MT-008', stationBaseId: 503, startOriginalDate: '2026-06-30',
    problemTypeNames: '运营问题、硬件问题', problemTypeIds: [5, 1],
    problemDetail: '夏季高温导致散热系统超负荷', recovered: 1, endOriginalDate: '2026-07-05',
    impactDays: 5, taskRecord: 7, source: 'IMPORT', modifyUser: 'wangwu', modifyTime: '2026-07-05 11:00:00',
  },
  {
    id: 10025, supplier: '京东', region: '华东', province: '上海', city: '上海市',
    stationName: '上海浦东网点', provinceId: 2, cityId: 21, vehicleName: 'JD-010', stationBaseId: 201, startOriginalDate: '2026-07-21',
    problemTypeNames: '路权问题', problemTypeIds: [4],
    problemDetail: '大型活动期间临时交通管制', recovered: 0, endOriginalDate: null,
    impactDays: 9, taskRecord: 0, source: 'MANUAL', modifyUser: 'zhangsan', modifyTime: '2026-07-29 12:00:00',
  },
  {
    id: 10026, supplier: '新石器', region: '华北', province: '北京', city: '北京市',
    stationName: '北京朝阳网点', provinceId: 1, cityId: 11, vehicleName: 'XM-008', stationBaseId: 101, startOriginalDate: '2026-07-07',
    problemTypeNames: '硬件问题、软件问题', problemTypeIds: [1, 2],
    problemDetail: '激光雷达点云数据丢失，疑似硬件接触不良', recovered: 1, endOriginalDate: '2026-07-10',
    impactDays: 3, taskRecord: 2, source: 'MANUAL', modifyUser: 'lisi', modifyTime: '2026-07-10 09:30:00',
  },
  {
    id: 10027, supplier: '美团', region: '华东', province: '江苏', city: '南京市',
    stationName: '南京江宁网点', provinceId: 4, cityId: 41, vehicleName: 'MT-009', stationBaseId: 401, startOriginalDate: '2026-07-16',
    problemTypeNames: '软件问题', problemTypeIds: [2],
    problemDetail: '路径规划算法在复杂路口死循环', recovered: 1, endOriginalDate: '2026-07-17',
    impactDays: 1, taskRecord: 3, source: 'MANUAL', modifyUser: 'wangwu', modifyTime: '2026-07-17 18:00:00',
  },
  {
    id: 10028, supplier: '京东', region: '华南', province: '广东', city: '广州市',
    stationName: '广州天河网点', provinceId: 5, cityId: 51, vehicleName: 'JD-011', stationBaseId: 501, startOriginalDate: '2026-07-13',
    problemTypeNames: '运营问题', problemTypeIds: [5],
    problemDetail: '高峰期订单积压，车辆周转不足', recovered: 0, endOriginalDate: null,
    impactDays: 17, taskRecord: 20, source: 'IMPORT', modifyUser: 'zhangsan', modifyTime: '2026-07-29 14:00:00',
  },
  {
    id: 10029, supplier: '新石器', region: '华东', province: '江苏', city: '苏州市',
    stationName: '苏州工业园网点', provinceId: 4, cityId: 42, vehicleName: 'XM-009', stationBaseId: 402, startOriginalDate: '2026-07-09',
    problemTypeNames: '交通事故、路权问题', problemTypeIds: [3, 4],
    problemDetail: '雨天路滑撞上护栏，同时该路段限行', recovered: 1, endOriginalDate: '2026-07-15',
    impactDays: 6, taskRecord: 0, source: 'MANUAL', modifyUser: 'lisi', modifyTime: '2026-07-15 10:00:00',
  },
  {
    id: 10030, supplier: '美团', region: '华北', province: '北京', city: '北京市',
    stationName: '北京朝阳网点', provinceId: 1, cityId: 11, vehicleName: 'MT-010', stationBaseId: 101, startOriginalDate: '2026-07-27',
    problemTypeNames: '硬件问题', problemTypeIds: [1],
    problemDetail: '充电接口故障，无法正常充电', recovered: 0, endOriginalDate: null,
    impactDays: 3, taskRecord: 0, source: 'MANUAL', modifyUser: 'wangwu', modifyTime: '2026-07-29 16:30:00',
  },
];

// 导入日志
const importLogStore = [
  {
    taskId: 'task_20260729_001', fileName: '批量上报异常_20260729.xlsx', status: 'SUCCESS',
    statusDesc: '全部成功', totalCount: 50, successCount: 50, failCount: 0,
    operator: 'zhangsan', operateTime: '2026-07-29 14:30:00',
  },
  {
    taskId: 'task_20260728_001', fileName: '批量上报异常_20260728.xlsx', status: 'PARTIAL_FAIL',
    statusDesc: '部分失败', totalCount: 30, successCount: 25, failCount: 5,
    operator: 'lisi', operateTime: '2026-07-28 10:00:00',
  },
  {
    taskId: 'task_20260727_001', fileName: '批量上报异常_20260727.xlsx', status: 'PROCESSING',
    statusDesc: '导入中', totalCount: 20, successCount: 0, failCount: 0,
    operator: 'wangwu', operateTime: '2026-07-27 16:00:00',
  },
  {
    taskId: 'task_20260725_001', fileName: '批量上报异常_20260725.xlsx', status: 'SUCCESS',
    statusDesc: '全部成功', totalCount: 80, successCount: 80, failCount: 0,
    operator: 'zhangsan', operateTime: '2026-07-25 09:00:00',
  },
  {
    taskId: 'task_20260722_001', fileName: '批量上报异常_20260722.xlsx', status: 'PARTIAL_FAIL',
    statusDesc: '部分失败', totalCount: 100, successCount: 92, failCount: 8,
    operator: 'lisi', operateTime: '2026-07-22 11:30:00',
  },
  {
    taskId: 'task_20260720_001', fileName: '批量上报异常_20260720.xlsx', status: 'SUCCESS',
    statusDesc: '全部成功', totalCount: 45, successCount: 45, failCount: 0,
    operator: 'wangwu', operateTime: '2026-07-20 15:00:00',
  },
  {
    taskId: 'task_20260718_001', fileName: '批量上报异常_20260718.xlsx', status: 'SUCCESS',
    statusDesc: '全部成功', totalCount: 60, successCount: 60, failCount: 0,
    operator: 'zhangsan', operateTime: '2026-07-18 10:00:00',
  },
  {
    taskId: 'task_20260715_001', fileName: '批量上报异常_20260715.xlsx', status: 'PARTIAL_FAIL',
    statusDesc: '部分失败', totalCount: 200, successCount: 185, failCount: 15,
    operator: 'lisi', operateTime: '2026-07-15 14:00:00',
  },
  {
    taskId: 'task_20260710_001', fileName: '批量上报异常_20260710.xlsx', status: 'SUCCESS',
    statusDesc: '全部成功', totalCount: 35, successCount: 35, failCount: 0,
    operator: 'wangwu', operateTime: '2026-07-10 08:30:00',
  },
  {
    taskId: 'task_20260705_001', fileName: '批量上报异常_20260705.xlsx', status: 'SUCCESS',
    statusDesc: '全部成功', totalCount: 120, successCount: 120, failCount: 0,
    operator: 'zhangsan', operateTime: '2026-07-05 16:00:00',
  },
];

// ============ 辅助函数 ============

const calcImpactDays = (start: string, end: string | null): number => {
  if (!end) {
    const today = new Date().toISOString().slice(0, 10);
    const diff = new Date(today).getTime() - new Date(start).getTime();
    return Math.max(Math.ceil(diff / 86400000) + 1, 1);
  }
  const diff = new Date(end).getTime() - new Date(start).getTime();
  return Math.max(Math.ceil(diff / 86400000) + 1, 1);
};

const now = () => new Date().toISOString().replace('T', ' ').slice(0, 19);

const idToNames = (ids: number[]): string =>
  ids
    .map((id) => problemTypeStore.find((t) => t.id === id)?.name || '')
    .filter(Boolean)
    .join('、');

// ============ 导出的 Mock 接口 ============

export const MOCK_DEVICE_LIST = [
  'JD-001', 'JD-002', 'JD-003', 'JD-004', 'JD-005',
  'JD-006', 'JD-007', 'JD-008', 'JD-009', 'JD-010', 'JD-011',
  'XM-001', 'XM-002', 'XM-003', 'XM-004', 'XM-005',
  'XM-006', 'XM-007', 'XM-008', 'XM-009',
  'MT-001', 'MT-002', 'MT-003', 'MT-004', 'MT-005',
  'MT-006', 'MT-007', 'MT-008', 'MT-009', 'MT-010',
];

export const MOCK_CASCADE_STATION_LIST = [
  {
    id: 1, name: '北京', children: [
      { id: 11, name: '北京市', children: [
        { id: 101, name: '北京朝阳网点' },
        { id: 102, name: '北京海淀网点' },
      ]},
    ],
  },
  {
    id: 2, name: '上海', children: [
      { id: 21, name: '上海市', children: [
        { id: 201, name: '上海浦东网点' },
        { id: 202, name: '上海徐汇网点' },
      ]},
    ],
  },
  {
    id: 3, name: '河北', children: [
      { id: 31, name: '石家庄市', children: [
        { id: 301, name: '石家庄长安网点' },
      ]},
    ],
  },
  {
    id: 4, name: '江苏', children: [
      { id: 41, name: '南京市', children: [
        { id: 401, name: '南京江宁网点' },
      ]},
      { id: 42, name: '苏州市', children: [
        { id: 402, name: '苏州工业园网点' },
      ]},
    ],
  },
  {
    id: 5, name: '广东', children: [
      { id: 51, name: '广州市', children: [
        { id: 501, name: '广州天河网点' },
      ]},
      { id: 52, name: '深圳市', children: [
        { id: 502, name: '深圳南山网点' },
        { id: 503, name: '深圳福田网点' },
      ]},
    ],
  },
];

export const MOCK_FILTERS = {
  supplier: [
    { code: 'JD', name: '京东' },
    { code: 'XINSHIQI', name: '新石器' },
    { code: 'MT', name: '美团' },
  ],
  problemType: [
    { code: '1', name: '硬件问题' },
    { code: '2', name: '软件问题' },
    { code: '3', name: '交通事故' },
    { code: '4', name: '路权问题' },
    { code: '5', name: '运营问题' },
    { code: '6', name: '其他问题' },
  ],
  recovered: [
    { value: '0', label: '未恢复' },
    { value: '1', label: '已恢复' },
  ],
  provinceAgency: [
    { value: '100000', label: '物流总部' },
    { value: '110000', label: '京津地区' },
    { value: '130000', label: '河北省区' },
    { value: '140000', label: '晋蒙地区' },
    { value: '150000', label: '内蒙省区' },
    { value: '210000', label: '辽宁省区' },
    { value: '220000', label: '吉林省区' },
    { value: '230000', label: '黑吉地区' },
    { value: '310000', label: '上海区' },
    { value: '320000', label: '江苏省区' },
    { value: '330000', label: '浙江省区' },
    { value: '340000', label: '安徽省区' },
    { value: '350000', label: '福建省区' },
    { value: '360000', label: '江西省区' },
    { value: '370000', label: '山东省区' },
    { value: '410000', label: '河南省区' },
    { value: '420000', label: '湖北省区' },
    { value: '430000', label: '湖南省区' },
    { value: '440000', label: '广东省区' },
    { value: '450000', label: '广西省区' },
    { value: '460000', label: '海南省区' },
    { value: '500000', label: '重庆区' },
    { value: '510000', label: '川藏地区' },
    { value: '520000', label: '贵州省区' },
    { value: '530000', label: '云南省区' },
    { value: '610000', label: '陕西省区' },
    { value: '620000', label: '甘青宁地区' },
    { value: '650000', label: '新疆省区' },
    { value: '810000', label: '港澳地区' },
  ],
};

export const MOCK_STATION_MAP: Record<string, { stationBaseId: number; stationName: string }> = {
  'JD-001': { stationBaseId: 101, stationName: '北京朝阳网点' },
  'JD-002': { stationBaseId: 101, stationName: '北京朝阳网点' },
  'JD-003': { stationBaseId: 201, stationName: '上海浦东网点' },
  'JD-004': { stationBaseId: 501, stationName: '广州天河网点' },
  'JD-005': { stationBaseId: 402, stationName: '苏州工业园网点' },
  'JD-006': { stationBaseId: 503, stationName: '深圳福田网点' },
  'JD-007': { stationBaseId: 201, stationName: '上海浦东网点' },
  'JD-008': { stationBaseId: 102, stationName: '北京海淀网点' },
  'JD-009': { stationBaseId: 301, stationName: '石家庄长安网点' },
  'JD-010': { stationBaseId: 201, stationName: '上海浦东网点' },
  'JD-011': { stationBaseId: 501, stationName: '广州天河网点' },
  'XM-001': { stationBaseId: 201, stationName: '上海浦东网点' },
  'XM-002': { stationBaseId: 301, stationName: '石家庄长安网点' },
  'XM-003': { stationBaseId: 502, stationName: '深圳南山网点' },
  'XM-004': { stationBaseId: 101, stationName: '北京朝阳网点' },
  'XM-005': { stationBaseId: 401, stationName: '南京江宁网点' },
  'XM-006': { stationBaseId: 202, stationName: '上海徐汇网点' },
  'XM-007': { stationBaseId: 502, stationName: '深圳南山网点' },
  'XM-008': { stationBaseId: 101, stationName: '北京朝阳网点' },
  'XM-009': { stationBaseId: 402, stationName: '苏州工业园网点' },
  'MT-001': { stationBaseId: 102, stationName: '北京海淀网点' },
  'MT-002': { stationBaseId: 401, stationName: '南京江宁网点' },
  'MT-003': { stationBaseId: 102, stationName: '北京海淀网点' },
  'MT-004': { stationBaseId: 202, stationName: '上海徐汇网点' },
  'MT-005': { stationBaseId: 301, stationName: '石家庄长安网点' },
  'MT-006': { stationBaseId: 501, stationName: '广州天河网点' },
  'MT-007': { stationBaseId: 402, stationName: '苏州工业园网点' },
  'MT-008': { stationBaseId: 503, stationName: '深圳福田网点' },
  'MT-009': { stationBaseId: 401, stationName: '南京江宁网点' },
  'MT-010': { stationBaseId: 101, stationName: '北京朝阳网点' },
};

export const MOCK_IMPORT_TEMPLATE = { url: 'https://example.com/template.xlsx' };
export const MOCK_IMPORT_UPLOAD = {
  taskNo: 'UPI202607310001',
  totalCount: 5,
  successCount: 5,
  failCount: 0,
  status: 'SUCCESS',
  resultDescription: '全部成功，共5条',
  failFileUrl: null,
  successFileUrl: null,
};
export const MOCK_ERROR_FILE = { url: 'https://example.com/errors.xlsx' };

// ============ CRUD 操作 ============

/** 查询问题类型列表 */
export const mockGetProblemTypes = () => [...problemTypeStore];

/** 新增问题类型 */
export const mockAddProblemType = (name: string): { success: boolean; message?: string } => {
  const exists = problemTypeStore.some(
    (t) => t.name.toLowerCase() === name.trim().toLowerCase()
  );
  if (exists) return { success: false, message: '该类型名称已存在' };
  const id = nextProblemTypeId++;
  problemTypeStore = [...problemTypeStore, { id, name: name.trim() }];
  return { success: true };
};

/** 查询异常记录列表（支持筛选 + 分页） */
export const mockGetRecordList = (params: any) => {
  let filtered = [...recordStore];

  if (params?.vehicleName) {
    filtered = filtered.filter((r) =>
      r.vehicleName.toLowerCase().startsWith(params.vehicleName.toLowerCase())
    );
  }
  if (params?.supplier?.length) {
    const supplierMap: Record<string, string> = { JD: '京东', XINSHIQI: '新石器', MT: '美团' };
    const names = params.supplier.map((code: string) => supplierMap[code] || code);
    filtered = filtered.filter((r) => names.includes(r.supplier));
  }
  if (params?.problemType?.length) {
    const typeMap: Record<string, string> = {
      '1': '硬件问题', '2': '软件问题', '3': '交通事故',
      '4': '路权问题', '5': '运营问题', '6': '其他问题',
    };
    const names = params.problemType.map((code: string) => typeMap[code] || code);
    filtered = filtered.filter((r) =>
      r.problemTypeNames.split('、').some((name: string) => names.includes(name))
    );
  }
  if (params?.recovered !== undefined && params?.recovered !== null) {
    filtered = filtered.filter((r) => r.recovered === params.recovered);
  }
  if (params?.hasTrip !== undefined && params?.hasTrip !== null) {
    filtered = filtered.filter((r) => (r.taskRecord > 0) === params.hasTrip);
  }
  if (params?.provinceIds?.length) {
    filtered = filtered.filter((r) => params.provinceIds.includes(r.provinceId));
  }
  if (params?.cityIds?.length) {
    filtered = filtered.filter((r) => params.cityIds.includes(r.cityId));
  }
  if (params?.stationBaseIds?.length) {
    filtered = filtered.filter((r) => params.stationBaseIds.includes(r.stationBaseId));
  }
  if (params?.startTime) {
    filtered = filtered.filter((r) => r.startOriginalDate >= params.startTime);
  }
  if (params?.endTime) {
    filtered = filtered.filter((r) => r.startOriginalDate <= params.endTime);
  }

  if (params?.qlProvinceAgencyCodes?.length) {
    // mock 数据暂无 qlProvinceAgencyCode 字段，不过滤
  }

  const page = params?.pageNum || 1;
  const pageSize = params?.pageSize || 20;
  const start = (page - 1) * pageSize;

  return {
    total: filtered.length,
    pages: Math.ceil(filtered.length / pageSize),
    pageNum: page,
    pageSize,
    list: filtered.slice(start, start + pageSize),
  };
};

/** 查询详情 */
export const mockGetRecordDetail = (recordId: number) => {
  const record = recordStore.find((r) => r.id === recordId);
  if (!record) return null;
  return {
    id: record.id,
    vehicleName: record.vehicleName,
    stationBaseId: MOCK_STATION_MAP[record.vehicleName]?.stationBaseId || 0,
    stationName: record.stationName,
    supplier: record.supplier,
    problemTypes: record.problemTypeIds,
    problemDetail: record.problemDetail,
    startOriginalDate: record.startOriginalDate,
    endOriginalDate: record.endOriginalDate,
  };
};

/** 查询指定车号与问题类型下的未恢复记录数量 */
export const mockGetUnrecoveredCount = (params: any) => {
  const matched = recordStore.filter(
    (r) =>
      r.vehicleName === params.vehicleName &&
      r.recovered === 0 &&
      params.problemTypeIds.some((id: number) => r.problemTypeIds.includes(id))
  );
  return matched.length;
};

/** 新增记录 */
export const mockAddRecord = (params: any) => {
  const id = nextId++;
  const problemTypeNames = idToNames(params.problemTypeIds || []);
  const station = MOCK_STATION_MAP[params.vehicleName];
  const record = {
    id: id,
    supplier: station?.stationName ? '京东' : '未知',
    region: '华北', province: '北京', city: '北京市',
    stationName: params.stationName,
    vehicleName: params.vehicleName,
    startOriginalDate: params.startTime || '',
    problemTypeNames,
    problemTypeIds: params.problemTypeIds || [],
    problemDetail: params.problemDetail || '',
    recovered: params.endTime ? 1 : 0,
    endOriginalDate: params.endTime || null,
    impactDays: calcImpactDays(params.startTime, params.endTime),
    taskRecord: 0,
    source: 'MANUAL',
    modifyUser: 'mock_user',
    modifyTime: now(),
  };
  recordStore = [...recordStore, record];
  return id;
};

/** 编辑记录 */
export const mockEditRecord = (params: any) => {
  recordStore = recordStore.map((r) => {
    if (r.id !== params.id) return r;
    const problemTypeNames = idToNames(params.problemTypeIds || []);
    return {
      ...r,
      vehicleName: params.vehicleName,
      stationName: params.stationName,
      problemTypeNames,
      problemTypeIds: params.problemTypeIds || [],
      problemDetail: params.problemDetail || '',
      startOriginalDate: params.startTime || r.startOriginalDate,
      endOriginalDate: params.endTime || null,
      recovered: params.endTime ? 1 : 0,
      impactDays: calcImpactDays(params.startTime || r.startOriginalDate, params.endTime),
      modifyUser: 'mock_user',
      modifyTime: now(),
    };
  });
};

/** 删除记录 */
export const mockDeleteRecord = (id: number) => {
  recordStore = recordStore.filter((r) => r.id !== id);
};

/** 根据车号查询站点 */
export const mockGetStationByVehicle = (vehicleName: string) => {
  return MOCK_STATION_MAP[vehicleName] || { stationBaseId: 0, stationName: '' };
};

/** 查询导入日志 */
export const mockGetImportLogList = (params?: any) => {
  let filtered = [...importLogStore];
  if (params?.startDate) {
    filtered = filtered.filter((r) => r.operateTime.slice(0, 10) >= params.startDate);
  }
  if (params?.endDate) {
    filtered = filtered.filter((r) => r.operateTime.slice(0, 10) <= params.endDate);
  }
  const page = params?.page || 1;
  const pageSize = params?.pageSize || 20;
  const start = (page - 1) * pageSize;
  return {
    total: filtered.length,
    pages: Math.ceil(filtered.length / pageSize),
    pageNum: page,
    pageSize,
    list: filtered.slice(start, start + pageSize),
  };
};
